<template>

<div class="login-wrap" >
   <!-- <div class="head_login">

    </div> -->
    <div class="login_img">
        <img src="../../static/logo.png"/>
    </div>
    <div class="login_dl" >
        <el-form label-position="left"
        :model="ruleForm" :rules="rules" ref="ruleForm" label-width="0px"
          class="demo-ruleForm login-container">
          <h5 class="title">{{login_title}}</h5>
          <el-form-item prop="username " style="margin-top: 20px;">
            <el-input type="text" style="height: 35px !important;"
             v-model="ruleForm.username" id="username" auto-complete="off" placeholder="账号"></el-input>
          </el-form-item>
          <el-form-item prop="password">
            <el-input type="password"
             v-model="ruleForm.password" id="password" auto-complete="off" placeholder="密码"></el-input>
          </el-form-item>
          <!-- <el-form-item prop="captcha">
            <el-input style="width: 25% !important;" type="text" v-model="ruleForm.captcha" auto-complete="off" placeholder="验证码"></el-input>
            <img :src="imgurl" id="loadcode"  @click="changeImg()" style="cursor: pointer; margin-top: 1px;"
             v-if="min == true" />
            <span @click="changeImg()"
              style="text-decoration:underline; margin-left: 10px;
               color: rgb(64, 158, 255); cursor: pointer;">换一张</span>
          </el-form-item> -->
         <!-- <el-checkbox class="remember" v-model="rememberpwd">记住密码</el-checkbox> -->
          <el-form-item style="width:100%;">
            <el-button type="primary" style="width:100%;" @click="submitForm('ruleForm')" :loading="logining">登录</el-button>
          </el-form-item>
        </el-form>
    </div>

  </div>
</template>
<script type="text/ecmascript-6">
import { login, captcha ,getuserinfo,mmts} from '../api/baseset.js'
import { setCookie, getCookie, delCookie } from '../utils/util'
import md5 from 'js-md5'
export default {
  name: 'login',
  data() {
    return {
      //定义loading默认为false
      logining: false,
      // 记住密码
      rememberpwd: false,
      login_title:"",
      ruleForm: {
        //username和password默认为空
        username: '',
        password: '',
       // captcha: '',
       // uniqid: '',
      },
      domain_url:'',
      min: true,
      imgurl: '/api/login/captcha',
      //rules前端验证
      rules: {

       /* password: [{ required: true, message: '请输入密码', trigger: 'blur' }], */
         username: [{ required: true, message: '请输入账号', trigger: 'blur' }],
      /* captcha: [{ required: true, message: '请输入验证码', trigger: 'blur' }], */
      }
    }
  },
  // 创建完毕状态(里面是操作)
  created() {

    // 获取存在本地的用户名密码
   // this.getuserpwd();
    // 验证码接口
   /* captcha().then((res) => {
      this.imgurl =  this.imgurl;
      this.ruleForm.uniqid=''
    }); */
    this.domain_url = window.location.hostname;

    this.login_title ='陇教云通睿心理测评系统(学生端)'
    if(this.domain_url =='shanxi.mxlcp.bi-soft.cn'){
        this.login_title ='陕西教育云通睿心理测评系统(学生端)'
    }else if(this.domain_url =='gansu.mxlcp.bi-soft.cn'){
         this.login_title ='陇教云通睿心理测评系统(学生端)'
    }


  },
  // 里面的函数只有调用才会执行
  methods: {
    // 获取用户名密码
    getuserpwd() {
      if (getCookie('user') != '' && getCookie('pwd') != '') {
        this.ruleForm.username = getCookie('user')
        this.ruleForm.password = getCookie('pwd')
        this.rememberpwd = true
      }
    },
    // 更新验证码
    changeImg() {
      // this.imgurl = ''
      this.min = false
      captcha().then((res) => {
        this.min = true;
        var num=Math.ceil(Math.random()*10);
        this.imgurl =  this.imgurl +'?t=' +num;
       // this.ruleForm.uniqid=res.uniqid
      });
    },
    hquserinfo(userName){
       let param = {userName:userName};
      mmts(param)
       .then(res => {

         this.loading = false
         if (res.code != 200) {
          } else {

           if(res.data == false){

              this.wxts('温馨提示','您的密码为初始机密，请及时修改','/user/upassedit');
           }

         }
       })
       .catch(err => {

       })

    },
    wxts(title,content,url){

      this.$confirm(content, title, {
                confirmButtonText: '立即修改',
                cancelButtonText: '取消',
                type: 'warning'
              }).then(() => {
                     this.$router.push(url);
              }).catch(() => {

              });

    },

    //获取info列表
    submitForm(formName) {

       if(this.ruleForm.username == ''){
         this.$message.error('用户名不能为空！')
         this.logining = false
         document.getElementById('username').focus();
         return false
       }
       if(this.ruleForm.password == ''){
         this.$message.error('密码不能为空！')
         this.logining = false
         document.getElementById('password').focus();
         return false
       }
      this.$refs[formName].validate(valid => {

        if (valid) {
           login(this.ruleForm).then(res => {

             if (res.data.code == 200) {
               //return ;
               if (this.rememberpwd) {
                 //保存帐号到cookie，有效期7天
                 setCookie('user', this.ruleForm.username, 7)
                 //保存密码到cookie，有效期7天
                 setCookie('pwd', this.ruleForm.password, 7)
               } else {
                 delCookie('user')
                 delCookie('pwd')
               }

               //如果请求成功就让他2秒跳转路由
               setTimeout(() => {
                 this.logining = false
                 // 缓存token
                 localStorage.setItem('logintoken', res.data.token)
                 // 缓存用户个人信息
                 if(res.data.defaultPassword == false ){
                    this.wxts('温馨提示','您的账户当前使用的是初始密码，为了保障账户安全，请尽快修改密码','/user/upassedit');
                  }

                  //this.hquserinfo(res.data.userId);
                 localStorage.setItem('userdata', JSON.stringify(res.data))
                   this.getuserinfos(res.data.userId);
                 this.$store.commit('login', 'true')
                 this.$router.push({ path: '/base/index' })
               }, 1000)
             } else {
               this.$message.error(res.data.msg)
               this.logining = false
			  // this.changeImg()
               return false
             }
           })
        } else {

         /* this.$message.error('用户名或密码不能为空！')
          this.logining = false
          return false */
        }
      })
    },
    getuserinfos(userId){
        let datas = {userId:userId}
        getuserinfo(datas)
         .then(res => {

          this.loading = false
           if (res.code != 200) {
             this.$message({
               type: 'info',
               message: res.msg
             })
           } else {

            this.userinfos = res.data
            localStorage.setItem('user_infos', JSON.stringify( this.userinfos))

           }
         })
         .catch(err => {
           this.loading = false
           this.$message.error('数据加载失败，请稍后再试！')
         })
    }

  }
}
</script>

<style scoped>

.login-wrap {
  box-sizing: border-box;
  width: 100%;
  height: 100%;

background-image: url("../../static/login/img/logbjt3.jpg");
 /* background-image: url("../../static/login/img/shanxi_login.png"); */
/* background-color: #EFEFF4; */
  /* background-color: #444444; */
  background-position: center center;
  background-repeat: no-repeat;
  background-attachment: fixed;
  background-size: cover;

  /* border: solid 1px red; */
}
.head_login{
  width: 100%;
  height: 100px;
  background-image: url("../../static/login_top.png");
  margin-top: 0 px !important;
}

.login-container {
  border-radius: 10px;
  margin: 0px;
  width: 100%;
  padding: 5px 15px 15px 15px;
  background: #fff;
  /* border: 1px solid #eaeaea;

  box-shadow: 0 0 20px 2px rgba(0, 0, 0, 0.1); */
}

.title {
  margin: 0px auto 10px auto;
  text-align: center;
  color: #505458;
}

.remember {
  margin: 0px 0px 35px 0px;
}

.code-box {
  text-align: right;
}

.codeimg {
  height: 40px;
}
.login_img{
  width: 100%;
  height: 250px;

}
.login_img img{
  width:100%;
  height: 100%;
}
.login_dl{
  width: 90%;
  height:auto;
  margin: 0 auto;
  padding-top: 25px;
  border-radius: 10px 10px 10px 10px;
  background-color: white;
 /* box-shadow: 2px 2px 2px 2px #ccc; */
/*  border: solid 1px #ccc; */
}
#loadcode{
  width: 50%;
  height: 38px ;
}
.el-input__inner{
  height: 35px !important;
  line-height: 35px !important;
}
</style>



// WEBPACK FOOTER //
// src/views/login.vue